import { render, staticRenderFns } from "./UnReadMsgPopup.vue?vue&type=template&id=3a668fa8&scoped=true"
import script from "./UnReadMsgPopup.vue?vue&type=script&lang=js"
export * from "./UnReadMsgPopup.vue?vue&type=script&lang=js"
import style0 from "./UnReadMsgPopup.vue?vue&type=style&index=0&id=3a668fa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a668fa8",
  null
  
)

export default component.exports